import { create } from 'zustand';
import { INATTIVITA_SESSIONE_MS, type SessioneTecnica } from '@emacomfort/domain';

interface StatoSessione {
  sessione: SessioneTecnica | null;
  ultimaAttivita: number;
  motivoUscita: 'scaduta' | null;
  accedi(sessione: SessioneTecnica): void;
  tocca(): void;
  esci(motivo?: 'scaduta'): void;
}

/**
 * Sessione tecnica lato client. È solo memoria di cortesia: l'autorizzazione
 * la verifica la centralina/il cloud a ogni richiesta (RNF-22). La scadenza
 * per inattività (RNF-25) è applicata anche qui per non lasciare il pannello
 * tecnico aperto a muro.
 */
export const useSessioneTecnica = create<StatoSessione>()((set) => ({
  sessione: null,
  ultimaAttivita: Date.now(),
  motivoUscita: null,
  accedi: (sessione) => set({ sessione, ultimaAttivita: Date.now(), motivoUscita: null }),
  tocca: () => set({ ultimaAttivita: Date.now() }),
  esci: (motivo) => set({ sessione: null, motivoUscita: motivo ?? null }),
}));

export function minutiRimanenti(ultimaAttivita: number, adesso: number): number {
  return Math.max(0, Math.ceil((ultimaAttivita + INATTIVITA_SESSIONE_MS - adesso) / 60_000));
}

export function sessioneScaduta(ultimaAttivita: number, adesso: number): boolean {
  return adesso - ultimaAttivita > INATTIVITA_SESSIONE_MS;
}
